export default __webpack_public_path__ + "static/media/logoFooter.1f084aff.PNG";